export default __webpack_public_path__ + "static/media/banner-bg-2.82d28dd2.png";